import { GlobalParticipantType, GlobalParticipantTypeValue } from '@vendasta/protos/conversation/v1';

interface ConversationResponseLike {
  conversation?: {
    subjectParticipants?: { participantType?: string | number }[];
  } | null;
}

function hasParticipantType(
  data: ConversationResponseLike | null | undefined,
  type: keyof typeof GlobalParticipantTypeValue,
): boolean {
  const numericType: number = GlobalParticipantTypeValue[type];
  return !!data?.conversation?.subjectParticipants?.some(
    (p) => p.participantType === type || p.participantType === numericType,
  );
}

export function isLeadCaptured(data: ConversationResponseLike | null | undefined): boolean {
  return hasParticipantType(data, GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_CUSTOMER);
}

export function isAnonymous(data: ConversationResponseLike | null | undefined): boolean {
  return hasParticipantType(data, GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_ANONYMOUS);
}
